import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { createUseStyles } from "react-jss";
import { QuestionStyleType } from "types";

export const Emoji: React.FC<QuestionStyleType> = ({
  section,
  question,
  formValues,
  handleButtonRatingClick,
}) => {
  const classes = useStyles();

  return (
    <div className="text-center">
      <Row className="flex-nowrap">
        {question.answers.map((answer, idx) => {
          return (
            <Col
              className="p-0"
              onClick={() =>
                handleButtonRatingClick(
                  section.sectionCode,
                  question.id,
                  answer,
                  question.answers.length
                )
              }
              key={idx}
            >
              <motion.div whileTap={{ scale: 0.93 }}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{
                    duration: 0.5,
                    delay: idx / 8,
                    ease: [0, 0.71, 0.2, 1.01],
                  }}
                  className={`${classes.buttonRatingEmoji} ${
                    formValues.find((q) => q.questionId === question.id)
                      ?.answer === answer
                      ? classes.selectedButton
                      : ""
                  }`}
                >
                  <i className={`las la-${question.answersMeaning![answer]}`} />
                </motion.div>
              </motion.div>
            </Col>
          );
        })}
      </Row>
      <Row>
        <Col className={`text-start ${classes.scoreDescription}`}>
          Insoddisfacente
        </Col>
        <Col className={`text-end ${classes.scoreDescription}`}>Eccellente</Col>
      </Row>
    </div>
  );
};

const useStyles = createUseStyles({
  selectedButton: {
    backgroundColor: "#EDEFF8",
  },
  buttonRatingEmoji: {
    width: 60,
    height: 60,
    display: "inline-block",
    border: "1px solid #D2D7ED",
    borderRadius: "100%",
    alignContent: "center",
    margin: 5,
    fontSize: 35,
    fontWeight: 700,
    textAlign: "center",
    padding: 2,
  },
  scoreDescription: {
    fontSize: 14,
  },
});
